import React from 'react';
import { SpamManagement } from '@/components/admin/SpamManagement';

const AdminSpam = () => {
  return <SpamManagement />;
};

export default AdminSpam;